"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageDirection = exports.Locale = exports.RTL_LOCALES = exports.ALL_LOCALES = exports.DEFAULT_LOCALE = void 0;
/* istanbul ignore file -- no need to test exports */
__exportStar(require("./hooks"), exports);
var constants_1 = require("./lib/constants");
Object.defineProperty(exports, "DEFAULT_LOCALE", { enumerable: true, get: function () { return constants_1.DEFAULT_LOCALE; } });
Object.defineProperty(exports, "ALL_LOCALES", { enumerable: true, get: function () { return constants_1.ALL_LOCALES; } });
Object.defineProperty(exports, "RTL_LOCALES", { enumerable: true, get: function () { return constants_1.RTL_LOCALES; } });
Object.defineProperty(exports, "Locale", { enumerable: true, get: function () { return constants_1.Locale; } });
var language_direction_1 = require("./lib/language-direction");
Object.defineProperty(exports, "LanguageDirection", { enumerable: true, get: function () { return language_direction_1.LanguageDirection; } });
__exportStar(require("./lib/locales"), exports);
__exportStar(require("./lib/localeUtils"), exports);
__exportStar(require("./middleware/responses"), exports);
//# sourceMappingURL=index.js.map